import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  deductionExemptionData: [],
  is_changes_through_manage_cycle:{},
  regime:"new"
};

export const deductionExemptionSlice = createSlice({
  name: 'deductionExemption',
  initialState,
  reducers: {
    setDeductionExemptionData: (state, action) => {
      state.deductionExemptionData = action.payload;
    },
    setIsChangesThroughManageCycle: (state, action) => {
      state.is_changes_through_manage_cycle = action.payload;
    },
    setRegimeCycle: (state, action) => {
      state.regime = action.payload;
    },

  },
});

export const { setDeductionExemptionData, setIsChangesThroughManageCycle, setRegimeCycle } = deductionExemptionSlice.actions;
export default deductionExemptionSlice.reducer;
